/** @jsx jsx */
import { css, jsx } from '@emotion/core'

export function NewsBalancedTopicsSection({ children }) {
  return <div css={styles.topicsContainer}>{children}</div>
}

const styles = {
  topicsContainer: css`
    &:has(li:nth-child(4)) {
      column-count: 2;
      column-gap: 2rem;
    }
  `,
}
